//import Chart from 'chart.js/auto';

(async function() {
  
  const charts = document.querySelectorAll('.chart');
  const myCharts = [];

  const totalizer = {
    id: 'totalizer',
  
    beforeUpdate: chart => {
      let utmost  = {};
            let stacktotal = {};
            chart.data.datasets.forEach((dataset, datasetIndex) => {
              if(chart.isDatasetVisible(datasetIndex)){
                utmost[dataset.stack] = datasetIndex;
                
                dataset.data.forEach((value, index) => {
                  if(stacktotal[dataset.stack]) {
                    stacktotal[dataset.stack][index] = (stacktotal[dataset.stack][index]||0)+value;
                  }else{
                    stacktotal[dataset.stack] = [];
                    stacktotal[dataset.stack][index] = value;
                  }
                })
              }
            });
            
            //console.log(JSON.stringify(stacktotal));
            
            chart.$totalizer = {
              utmost: utmost,
              stacktotal: stacktotal
            }
    }
  }

  let myChart, chartType;
  let parentDiv, dataDiv, dataItems, data, data2;
  let jsonLabelData, barlabels, largestNumber;
  let legend_position, font_legend, font_datalabel, font_barlabel, innerWidth, legend_display, legend_align, legend_padding, legend_box;
  
  if (charts) {
    charts.forEach((chart) => {

      ctx = chart.getContext("2d");
      innerWidth = window.innerWidth;
      
      // positions
      if (innerWidth <= 575) {
        legend_position = 'bottom';
        legend_align = 'start';
        legend_padding = 22;
        legend_box = 20;
        font_legend = 14;
        font_datalabel = 10;
        font_barlabel = 16;
      } else if (innerWidth > 575 && innerWidth <= 1199) {
        legend_position = 'bottom';
        legend_align = 'start';
        legend_padding = 29;
        legend_box = 20;
        font_legend = 14;
        font_datalabel = 18;
        font_barlabel = 22;
      } else {
        legend_position = 'right';
        legend_align = 'center';
        legend_padding = 20;
        legend_box = 30;
        font_legend = 16;
        font_datalabel = 18;
        font_barlabel = 24;
      }

      // type - data attr
      chartType = chart.dataset.charttype;

      // Node elements
      parentDiv = chart.parentElement;
      dataDiv = parentDiv.querySelector('.data');

      largestNumber = dataDiv.dataset.largest;

      // get bar labels
      barlabels = JSON.parse(dataDiv.dataset.barlabels);
      // prepare data array
      data = {
          labels: barlabels, // array from attribute
          datasets: []
      };

      // add dataset stacked bar
      dataItems = dataDiv.querySelectorAll('span');
      if (dataItems.length == 1) {
        legend_display = false;
      } else {
        legend_display = true;
      }

      // convert NodeList to array
      dataItems = Array.from(dataItems);

      // chart output
      if (chartType == 'bar') {
        // stacked bar

        // add data to dataset
        dataItems.map((item) => {
          // data and label
          data.datasets.push({ 
                "label" : item.dataset.labelname,
                "data"  : JSON.parse(item.dataset.numbers),
                "backgroundColor" : item.dataset.color 
          });
        });
    
        // chart output
        var config = {
            type: chartType,
            data: data,
            plugins: [ChartDataLabels,totalizer],
            options: {
              animation: {
                duration: 400,
                easing: 'linear',
              },
              layout: {
                padding: {
                  top: 35,
                  bottom: 30,
                }
              },
              elements: {
                bar: {
                  borderWidth: 2,
                  borderColor: '#000C3E',
                  //borderSkipped: false,
                }
              },
              plugins: {
                title: {
                  display: false,
                },
                legend: {
                  reverse: true,
                  display: legend_display,
                  position: legend_position,
                  align: legend_align,
                  labels: {
                    boxWidth: legend_box,
                    boxHeight: legend_box,
                    padding: legend_padding,
                    textAlign: 'left',
                    color: '#000C3E',
                    font: {
                      size: font_legend,
                      weight: 'normal',
                    },
                  }
                },
                tooltip: {
                  backgroundColor: '#000C3E',
                  titleFont: {
                    size: 18,
                  },
                  bodyFont: {
                    size: 16,
                  },
                  padding: 10,
                  boxPadding: 6,
                },
                datalabels: {
                  formatter: (value, ctx) => {
                    //console.log(ctx.chart.$totalizer.stacktotal[ctx.dataset.stack][ctx.dataIndex])
                    var sum = ctx.chart.$totalizer.stacktotal[ctx.dataset.stack][ctx.dataIndex];
                    return new Intl.NumberFormat('de-CH').format(sum); // set locale ...
                  },
                  align: 'top',
                  anchor: 'end',
                  color: '#000C3E',
                  labels: {
                    title: {
                      font: {
                        size: font_datalabel,
                        weight: 'normal'
                      }
                    },
                  },
                  display: function(ctx) {
                    return ctx.chart.$totalizer.utmost[ctx.dataset.stack] === ctx.datasetIndex;
                  }
                }
              },
              responsive: true,
              maintainAspectRatio: false, // height with sass wrapper
              scales: {
                x: {
                  stacked: true,
                  border: {
                    width: 3,
                    color: '#000C3E',
                  },
                  grid: {
                    display: false,
                    offset: true,
                  },
                  ticks: { // labels x, year nr
                    color: '#000C3E',
                    font: {
                      size: font_barlabel,
                      weight: 'bold',
                    },
                    beginAtZero: true,
                  },
                },
                y: {
                  //display: false,
                  stacked: true,
                  suggestedMax: largestNumber,
                  border: {
                    width: 0,
                    color: '#FFFFFF',
                  },
                  grid: {
                    color: '#FFFFFF',
                    display: true,
                    offset: true,
                  },
                  ticks: { // labels y hide
                    display: false,
                  }
                }
              }
            }
          };

      } else {
        // doughnot

        // only 1 in array
        dataItem = dataItems[0];
        data = {
          labels: barlabels,
          datasets: [
            {
              label: dataItem.dataset.labelname,
              data: JSON.parse(dataItem.dataset.numbers),
              backgroundColor: JSON.parse(dataItem.dataset.color),
              borderColor: '#000C3E',
              borderWidth: 2,
            },
          ]
        };

        // chart output
        var config = {
            type: chartType,
            data: data,
            options: {
              responsive: true,
              maintainAspectRatio: false, // height with sass wrapper
              plugins: {
                legend: {
                  display: true,
                  position: legend_position,
                  align: legend_align,
                  labels: {
                    boxWidth: legend_box,
                    boxHeight: legend_box,
                    padding: legend_padding,
                    textAlign: 'left',
                    color: '#000C3E',
                    font: {
                      size: font_legend,
                      weight: 'normal',
                    },
                  },
                },
                title: {
                  display: false,
                }
              }
            },
          };

      } // end bar / doughnut

      const myChart = new Chart(ctx, config);
      myCharts.push(myChart); // store the reference to the chart in the array
    });

    // how to get type??
    function afterResizing(myCharts) {
      var innerWidth = window.innerWidth;

      myCharts.forEach((chart) => {
        // general
        if (innerWidth <= 575) {
          chart.options.plugins.legend.position = 'bottom';
          chart.options.plugins.legend.align = 'start';
          chart.options.plugins.legend.labels.padding = 22;
          chart.options.plugins.legend.labels.boxWidth = 20;
          chart.options.plugins.legend.labels.boxHeight = 20;
          chart.options.plugins.legend.labels.font.size = 14;
        } else if (innerWidth > 575 && innerWidth <= 1199) {
          chart.options.plugins.legend.position = 'bottom';
          chart.options.plugins.legend.align = 'start';
          chart.options.plugins.legend.labels.padding = 29;
          chart.options.plugins.legend.labels.boxWidth = 20;
          chart.options.plugins.legend.labels.boxHeight = 20;
          chart.options.plugins.legend.labels.font.size = 14;
        } else {
          // large
          chart.options.plugins.legend.position = 'right';
          chart.options.plugins.legend.align = 'center';
          chart.options.plugins.legend.labels.padding = 20;
          chart.options.plugins.legend.labels.boxWidth = 30;
          chart.options.plugins.legend.labels.boxHeight = 30;
          chart.options.plugins.legend.labels.font.size = 16;
        }
        // more updates if bar
        if (chart.config.type === 'bar') {
          if (innerWidth <= 575) {
            chart.options.plugins.datalabels.labels.title.font.size = 10;
            chart.options.scales.x.ticks.font.size = 16;
          } else if (innerWidth > 575 && innerWidth <= 1199) {
            chart.options.plugins.datalabels.labels.title.font.size = 18;
            chart.options.scales.x.ticks.font.size = 22;
          } else {
            chart.options.plugins.datalabels.labels.title.font.size = 18;
            chart.options.scales.x.ticks.font.size = 24;
          }
        }

        chart.update('none');// no animations
      });
    }

    function debounce(func){
      var timer;
      return function(event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func,200,event);
      };
    }
    window.addEventListener("resize",debounce(function(e){
      afterResizing(myCharts);
    }));
  } // end if charts

})();